const MODULE_NAME = 'attendance';

const AttendanceSelector = {
    classList: (state) => state[MODULE_NAME].classList,
    isCheckAll: (state) => state[MODULE_NAME].isCheckAll,
};

export default AttendanceSelector;
